import React from 'react'

export default function Close(props) {
  return (
    <svg width={props.width ? props.width : "17"} height={props.height ? props.height : "17"} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.08333 8.08333L1 1M8.08333 8.08333L15.1667 15.1667M8.08333 8.08333L15.1667 1M8.08333 8.08333L1 15.1667" stroke={props.color ? props.color : "white"} strokeWidth="1.3333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
